<script setup lang="ts">
import { resizeImageAttrs } from '~/shared/lib/resizeImage';

const props = defineProps<{
  id: number;
  name: string;
  position: string;
  company?: string;
  photoUrl?: string;
  pending?: boolean;
}>();

const photo = computed(() =>
  resizeImageAttrs(props.photoUrl, { width: 72, height: 72, mode: 'fill' }),
);
</script>

<template>
  <NuxtLink
    :to="{ name: 'speaker-detail', params: { id } }"
    :class="[$style.card, { [$style.cardWithoutPending!]: !pending }]"
  >
    <div :class="$style.main">
      <div :class="$style.avatar">
        <img
          v-if="photoUrl"
          :src="photo.src"
          :srcset="photo.srcset"
          :alt="name"
          :class="$style.photo"
        />
        <div v-else :class="$style.placeholder" />
      </div>
      <div :class="$style.info">
        <div :class="$style.name">{{ name }}</div>
        <div :class="$style.position">
          {{ position }}{{ company ? `, ${company}` : '' }}
        </div>
      </div>
    </div>
    <div v-if="pending" :class="$style.pending">
      *приглашен, ожидается подтверждение
    </div>
  </NuxtLink>
</template>

<style module lang="scss">
.card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--space-1x);
  min-width: 0;
  min-height: 104px;
  padding: 16px;
  background-color: var(--color-white);
  box-sizing: border-box;
  text-decoration: none;
  color: inherit;
  cursor: pointer;
}

.cardWithoutPending {
  justify-content: center;
}

.main {
  display: flex;
  align-items: center;
  gap: var(--space-1-5x);
  min-width: 0;
}

.pending {
  @include text_caption2;
  font-family: var(--font-golos);
  color: #b2b2b2;
}

.avatar {
  width: 72px;
  height: 72px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  background-color: var(--color-gray-bg);
}

.photo {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.placeholder {
  width: 100%;
  height: 100%;
  background-color: var(--color-gray-bg);
}

.info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: var(--space-0-5x);
  text-align: left;
  min-width: 0;
  overflow: hidden;
}

.name {
  @include text_caption1_bold;
  color: var(--color-black-1);
  width: 100%;
}

.position {
  @include text_caption2;
  @include line_clamp(4);
  color: var(--color-gray-text);
  width: 100%;
}
</style>
